(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory((function webpackLoadOptionalExternalModule() { try { return require("SiAntiPaySpider"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["SiAntiPaySpider"], factory);
	else if(typeof exports === 'object')
		exports["SiAntiSpider"] = factory((function webpackLoadOptionalExternalModule() { try { return require("SiAntiPaySpider"); } catch(e) {} }()));
	else
		root["SiAntiSpider"] = factory(root["SiAntiPaySpider"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__45__) => {
return 